module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/earphone-624fe4890b249f4be5b8667292dfe6c8.svg&quot;;"